import { IS_SME } from "../constants/motor";
import * as actions from "../constants/motor";
import {
 getCustomerDetails,
 getProposal,
 getVehicleDetails,
} from "../../services/motorRetailService";
import { updateLoading } from "./commonActions";

export const set_vehicle_number = (data) => {
 return {
  type: actions.SET_VEHICLE_NUMBER,
  payload: data,
 };
};

export const setVehicleDetails = (data) => {
 return {
  type: actions.SET_VEHICLE_DETAILS,
  payload: data,
 };
};

export const updateVehicleDetails = (index, data) => {
 return {
  type: actions.UPDATE_VEHICLE_DETAILS,
  payload: {
   index,
   data,
  },
 };
};

export const setCustomerDetails = (data) => async (dispatch) => {
 dispatch(updateLoading(true));
 const response = await getCustomerDetails(data);
 dispatch({
  type: actions.SET_DRIVER,
  payload: { ...response, ...data },
 });
 dispatch(updateLoading(false));
};

export const updateLocalDriver = (data) => {
 return {
  type: actions.UPDATE_LOCAL_DRIVER,
  payload: data,
 };
};

export const removeDriver = (data) => {
 return {
  type: actions.REMOVE_DRIVER,
  payload: data,
 };
};

export const check_sme = (data) => {
 return {
  type: IS_SME,
  payload: {
   isSme: data,
  },
 };
};

export const set_policy_details = (data) => {
 return {
  type: actions.SET_POLICY_DETAILS,
  payload: data,
 };
};

export const get_proposal_details = (payload) => async (dispatch) => {
 dispatch(updateLoading(true));
 const response = await getProposal(payload);
 dispatch({
  type: actions.GET_PROPOSAL_DETAILS,
  payload: response,
 });
 dispatch(updateLoading(false));
};


export const set_payment_method = (data) => {
 return {
  type: actions.SET_PAYMENT_METHOD,
  payload: {
   paymentMethod: data,
  },
 };
};

export const setProposalDetails = (data) => {
 return {
  type: actions.SET_PROPOSAL_DETAILS,
  payload: data,
 };
};

export const updateCustomerDetails = (data) => {
 return {
  type: actions.UPDATE_CUSTOMER_DETAILS,
  payload: data,
 };
};

export const changeIsDriverRegistered = (data) => {  
  return {
   type: actions.CHANGE_DRIVER_REGISTERED,
   payload: data,
  };
};

export const changeIsDriverSelected = (val) => {  
  return {
   type: actions.CHANGE_DRIVER_SELECTED,
   payload: val,
  };
};

export const updateVehiclesDetails = (data) => {
 return {
  type: actions.UPDATE_VEHICLE_DETAILS,
  payload: data,
 };
};

export const getVehicleDetailsAction = (data) => async (dispatch) => {
 await dispatch(updateLoading(true));
 const response = await getVehicleDetails(data);
 await dispatch({
  type: actions.GET_VEHICLE_DETAILS,
  payload: response,
 });
 await dispatch(updateLoading(false));
};

export const updateLocalVehicleDetails = (data) => {
 return {
  type: actions.UPDATE_SINGLE_VEHICLE_DETAILS,
  payload: data,
 };
};

export const changedDeductable = () => ({
 type: actions.CHANGE_DEDUCTABLE,
});

export const removeVehicle = (vehicle) => {
 return {
  type: actions.REMOVE_VEHICLE,
  payload: vehicle,
 };
};

export const setActiveProgram = (program) => {
 return {
  type: actions.SET_ACTIVE_PROGRAM,
  payload: program,
 };
};

export const setActiveVehicle = (vehicleSerialNumber) => {
 return {
  type: actions.SET_ACTIVE_VEHICLE,
  payload: vehicleSerialNumber,
 };
};

export const setVehicleFeature = (features) => {
 return {
  type: actions.SET_VEHICLE_FEATURES,
  payload: features,
 };
};

export const setOTP = (OTP) => {
 return {
  type: actions.SET_OTP,
  payload: OTP,
 };
};

export const setAppSelectedVehicle = (data) => {
 return {
  type: actions.SET_SELECTED_VEHICLE,
  payload: data,
 };
};

export const UpdateQuotation = (data) => {
 return {
  type: actions.SET_QUOTATION,
  payload: data,
 };
};

export const UpdateQuotationRequest = (data) => {
 return {
  type: actions.UPDATE_QUOTATION_REQUEST,
  payload: data,
 };
};

export const updateFormsValue = (data) => {
 return {
  type: actions.UPDATE_FORMS_VALUES,
  payload: data,
 };
};
export const updateFormsStatus = (data) => {
 return {
  type: actions.UPDATE_FORMS_STATUS,
  payload: data,
 };
};
export const setTempVehicleArray = (data) => {
 return {
  type: actions.UPDATE_FORMS_STATUS,
  payload: data,
 };
};

export const setTmx = (payload) => ({
 type: actions.SET_TMX,
 payload,
});

export const setTmxVehicleDetails = (payload) => ({
 type: actions.SET_TMX_VEHICLE_DETAILS,
 payload,
});

export const saveQuotationRequestData = (payload) => ({
 type: actions.SAVE_QUOTATION_REQ_DATA,
 payload,
});

export const failedPayment = (payload) => ({
  type: actions.PAYMENTFAILED,
  payload,
 });


 export const LeadGeneratation = (payload) => ({
  type: actions.LEADGEN,
  payload,
 });

export const RESET_ACTION =()=>( {
  type: actions.RESET
})

export const STORE_OTP = (payload) => ({
    type: actions.STORE_OTP,
    payload,
})
export const SAVE_TOTAL_PRICE = (payload) => ({
  type: actions.SAVE_TOTAL_PRICE,
    payload,
})

export const updateInceptionDate = (data) => {
  return {
    type: actions.UPDATE_INCEPTION_DATE,
    payload: data,
  };
};

export const tawuniyaLeadAction = (payload) => ({
  type: actions.TAWUNIYA_LEAD,
    payload,
})